import React from 'react';
import PropTypes from 'prop-types';

import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { colors } from '@anyroad/theme';

import SimpleNumberInput from 'views/ui/form_elements/input/SimpleNumberInput';
import { cssNoSpin } from 'views/anyguide/messages/styles';
import { TextField } from './FormStyles';

// Check to see if the value is a number within the allowed number of decimal places
const validateDecimals = (roundTo, value) => {
  const regex = new RegExp(`^\\d+(\\.\\d{0,${roundTo}})?$`);
  return regex.test(value);
};

const NumberInput = styled(SimpleNumberInput)`
  ${TextField}
  ${cssNoSpin}
  text-align: left;
  &:focus {
    outline: none;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      background-color: #f0f0f0;
      color: ${colors.borderAction};
      cursor: not-allowed !important;
    `}
`;

const SimpleNumber = (props) => {
  const {
    field,
    handleNumberInput,
    max,
    roundTo,
    integerOnly,
    style,
    placeholder,
    disabled = false,
  } = props;
  const handleInputChange = (e) => {
    const { value } = e.target;

    if (!value) {
      return handleNumberInput(field.name, '');
    }
    if (max && parseFloat(value) > max) {
      return false;
    }
    if (roundTo) {
      const leadingZero = /^0(\d)$/;
      const match = leadingZero.exec(value);
      if (match) return handleNumberInput(field.name, match[1]);
      const validatedValue = validateDecimals(roundTo, value)
        ? value
        : field.value;
      return handleNumberInput(field.name, validatedValue);
    }
    return handleNumberInput(field.name, value);
  };

  let step;
  if (integerOnly) {
    step = '1';
  } else {
    step = 'any';
  }

  return (
    <NumberInput
      name={field.name}
      style={style}
      allow={integerOnly ? false : ['.']}
      value={field.value}
      step={step}
      onChange={handleInputChange}
      placeholder={placeholder}
      disabled={disabled}
    />
  );
};

SimpleNumber.propTypes = {
  field: PropTypes.object.isRequired,
  handleNumberInput: PropTypes.func.isRequired,
  integerOnly: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  roundTo: PropTypes.number,
  style: PropTypes.object,
};

SimpleNumber.defaultProps = {
  roundTo: 1,
};

export default SimpleNumber;
